import { requestHostHeaders } from '~/composables/constants/api'
import type { RequestHostHeadersType } from '~/composables/constants/api'

export default async (depositAmount: number, ppId: number, countryId: number): Promise<string | null> => {
  const result = await $fetch<{ id: number }>('/api/balance/create-invoice', {
    method: 'POST',
    body: {
      countryId,
      ppId,
      depositAmount,
    },
    headers: useRequestHeaders<RequestHostHeadersType>(requestHostHeaders),
  })

  return `ba${result.id}`
}
